import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { USERS } from '../constants'

const simulateToshiOsUnlink = async ({ id }: { id: number }) => {
  await fetchAPI({
    method: 'post',
    path: `/users/${id}/simulate_toshi_os_unlink`,
  })
}

export const useSimulateToshiOsUnlink = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(simulateToshiOsUnlink, {
    onSuccess: async () => {
      await queryClient.refetchQueries([USERS])

      toast({
        description: t('views.admin.users.simulate_toshi_os_unlink.success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
